import { render } from "./SecretInput.vue?vue&type=template&id=dc401784&ts=true"
import script from "./SecretInput.vue?vue&type=script&lang=ts"
export * from "./SecretInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__